import { AllHTMLAttributes } from 'react'
import './SkeletonBlock.scss'
import classNames from 'classnames'

type SkeletonBlockProps = AllHTMLAttributes<HTMLDivElement>
export function SkeletonBlock({ className, ...rest }: Readonly<SkeletonBlockProps>) {
  return <div className={classNames(`SkeletonBlock`, className ? className : '')} {...rest}></div>
}
